import { render, staticRenderFns } from "./VueButtonControl.vue?vue&type=template&id=528e2776&scoped=true&"
import script from "./VueButtonControl.vue?vue&type=script&lang=js&"
export * from "./VueButtonControl.vue?vue&type=script&lang=js&"
import style0 from "./VueButtonControl.vue?vue&type=style&index=0&id=528e2776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e2776",
  null
  
)

export default component.exports